var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29167 12.6667H8.30625M14.125 12.6667H14.1396M19.9583 12.6667H19.9729M27.25 12.6667C27.25 19.1096 21.3729 24.3333 14.125 24.3333C11.9795 24.3388 9.85966 23.866 7.91979 22.9494L1 24.3333L3.03438 18.9083C1.74667 17.1029 1 14.9621 1 12.6667C1 6.22375 6.87708 1 14.125 1C21.3729 1 27.25 6.22375 27.25 12.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbubble);
export default __webpack_public_path__ + "static/media/chatbubble.b3c9860d2aa35df33651e824e1182620.svg";
export { ForwardRef as ReactComponent };